module.exports = __webpack_public_path__ + "img/icon-mubiaoyouxi-logo.1bc8813d.png";